import { MParticleInstance } from './useConsentSyncing'

export const makeMParticleGlobalProperties = (mParticle: MParticleInstance) => {
  const params = new URLSearchParams(window.location.search)

  const envsMap: { [key: string]: string } = {
    development: 'dev',
    staging: 'staging',
    production: 'prod',
  }

  return {
    platform_source: 'web client',
    app_env: envsMap[process.env.NODE_ENV || 'development'],
    surface: 'embedded',
    logged_in_state: 'logged out',
    mp_device_id: mParticle.getDeviceId(),
    page_url: window.location.href,

    // url params
    campaign_source: params.get('utm_source'),
    campaign_medium: params.get('utm_medium'),
    campaign_name: params.get('utm_campaign'),
    campaign_term: params.get('utm_term'),
    campaign_content: params.get('utm_content'),
    attribution_id: params.get('attribution_id'),
  }
}
